<template>
  <div class="dropdown relative">
    <button
      @click="showOptions = !showOptions"
      :class="`btn btn-primary btn-raised dropdown-toggle employee_field_button btn-${color}`"
    >
      {{ status }}
    </button>
    <div v-if="showOptions" class="items bg-white">
      <div
        v-for="option in options"
        :key="option.key"
        @click="updateStatus(option)"
        class="item pl-2 pr-3 py-1"
      >
        {{ option.data_field_name }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    color() {
      switch (this.status_class) {
        case "green":
          return "success";
          break;

        case "red":
          return "danger";
          break;

        case "yellow":
          return "warning";
          break;

        case "baby_blue":
          return "info";
          break;

        case "bright_yellow":
          return "yellow-600";
          break;

        default:
          return "";
      }
    },
    options() {
      return this.statusOptions.filter((option) => {
        return option.data_field_group == "report_status";
      });
    },
  },
  data() {
    return {
      showOptions: false,
      status: "",
      status_class: "",
    };
  },
  created() {
    this.status = this.data.report_status[0];
    this.status_class = this.data.report_status[1];
  },
  methods: {
    updateStatus(option) {
      this.status = option.data_field_name;
      this.status_class = option.data_field_color;
      this.showOptions = false;

      this.$emit("updateDataField", {
        company_id: this.data.id,
        data_field_id: option.data_field_id,
        data_field_group: option.data_field_group,
        data_field_approve: option.data_field_status,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.btn {
  font-size: 9px !important;
}
.items {
  position: absolute;
  min-width: 100%;
  width: max-content;
  z-index: 10;

  .item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 9px !important;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      cursor: pointer;
    }
  }
}
</style>